const nouns = [
  `a captor`,
  `a flock of strange birds`,
  `a fire`,
  `anger`,
  `morbid curiosity`,
  `wonderment`,
  `bewildered animals`,
  `tall clouds`,
  `a warm mist`,
  `hysteria`,
  `an uncertain rain`,
  `the captain`,
  `a stowaway`,
];
export const peopleSingular = [
  "the cook",
  "the captain",
  "a small chimp",
  "a mutineer",
  "a bounty hunter",
  "a fanatic",
  "a missionary",
  "the deacon",
  "a couple",
  "a poet",
  "a $ADJECTIVE child",
  "someone",
  "a quiet fellow",
  "a widow",
  "a priestess",
  "a disgraced man",
  "a soldier",
];
export const peoplePlural = [
  "a husband and wife",
  "a man and his pet rat",
  "three beautiful birds of paradise",
  "the ship's crewmembers",
  "the prisoners",
];

export const illnesses = [
  "hysteria",
  "depression",
  "the flu",
  "revelation",
  "sickness",
  "despondence",
  "madness",
];
export const songs = ["song", "hymn", "tune", "prayer", "shanty"];

// We dock at a <place>
export const harbors = [
  "a remote island",
  "a small port",
  "a bustling harbor",
  "a large cave",
  "a fishing village",
  "what looks to be a resort",
  "a gathering of other ships",
];

export const landmarksThrough = [
  "a large gate made of rough-hewn marble",
  "a canal operated by a people whose faces we cannot make out",
  "a pitch-black cavern to avoid going around a large island",
  "a ship graveyard that must stretch for miles",
  "a dead reef",
  "a fleet of boats with $COLOR-colored sails",
  "the territory of some beast which stalks us endlessly but never attacks",
];

export const landmarksNearby = [
  "a lighthouse in the distance",
  "what looks like the decaying body of a sheep on a rowboat",
];

export const environments = [
  "in the windless night",
  "amid birdsong from birds we cannot see",
  "singing $ADJECTIVE songs",
  "on the $ADJECTIVE waves",
  "at dawn",
  "in the $ADJECTIVE glow of early evening",
  "in the $ADJECTIVE sunlight",
];

export const travel = ["cruise", "sail", "paddle"];

// We dock at a small port, where <placeDescriptor>
export const harborDescriptors = [
  "nobody speaks our language",
  "the men all wear heavy hoods",
  "everyone is shaved bald",
  "a large public funeral is happening",
  "there is some sort of celebration happening",
  "the weapons are purely ornamental",
  "a great hissing fills the air",
  "the ground rumbles softly",
];
export const trinkets = [
  "a tarnished silver necklace",
  "an old photograph of $PERSON",
  "a tattered manuscript written in $COLOR ink",
  "some meat of unknown origin",
  "a secret",
  "a plain leather belt",
  "a bottle of $COLOR dye",
];
export const colors = [
  "periwinkle",
  "magenta",
  "sunset",
  "opalescent",
  "honey",
  "punch",
  "mullberry",
  "lapis",
  "aegean",
  "peacock",
  "emerald",
  "graphite",
  "pewter",
  "carrot",
  "rose",
  "cherry",
];
export const concepts = [];
export const animals = [];
export default nouns;
